import * as Configuration from '../../../app.constants.js';

export class CrmService {
  constructor($http, $q, AsyncRequestFactory, AlertingFactory) {
    this.$http = $http;
    this.$q = $q;
    this.AsyncRequestFactory = AsyncRequestFactory;
    this.AlertingFactory = AlertingFactory;
  }

  // Organizations endpoints

  getOrganization(companyId, organizationId) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId;
    return this.$http.get(url);
  }

  updateOrganization(companyId, organization) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organization.id;
    return this.$http.put(url, organization);
  }

  getConfigurationPageFreshData(companyId, organizationId) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/configuration-page-fresh-data';
    return this.$http.get(url);
  }

  // Contacts endpoints
  getLinkedContact(companyId, userId, organizationId) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/linked-contacts/' + userId;
    return this.AsyncRequestFactory.get(companyId, url);
  }

  setLinkedContact(companyId, userId, organizationId, crmContact) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/linked-contacts/' + userId;

    let data = { crmContact: crmContact };
    return this.AsyncRequestFactory.post(companyId, url, data);
  }

  unsetLinkedContact(companyId, userId, organizationId) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/linked-contacts/' + userId;
    return this.AsyncRequestFactory.delete(companyId, url);
  }

  createCrmContact(companyId, organizationId, newCrmContact) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/create-crm-contact';

    let data = { newCrmContact: newCrmContact };
    return this.AsyncRequestFactory.post(companyId, url, data);
  }

  getLinkedContactsOrganizations(companyId, groupId) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/linked-contacts/' + groupId
      + '/active-organizations';
    return this.$http.get(url);
  }

  getObjectDescription(companyId, organizationId, objectName) {
    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/object-description/' + objectName;
    return this.$http.get(url);
  }

  directSmartSearchObject(companyId, organizationId, object_name, select_entries, search_entry) {
    let data = {
      select_entries: select_entries,
      search_entry: search_entry,
    };

    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/direct-smart-search-contact/';
    return this.$http.post(url, data);
  }

  directExactSearchObject(companyId, organizationId, object_name, select_entries, search_entry) {
    let data = {
      select_entries: select_entries,
      search_entry: search_entry,
    };

    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/direct-exact-search-contact/';
    return this.$http.post(url, data);
  }

  indirectSmartSearchObject(companyId, organizationId, object_name, select_entries, search_entry) {
    let data = {
      select_entries: select_entries,
      search_entry: search_entry,
    };

    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/indirect-smart-search-contact/';
    return this.$http.post(url, data);
  }

  indirectExactSearchObject(companyId, organizationId, object_name, select_entries, search_entry) {
    let data = {
      select_entries: select_entries,
      search_entry: search_entry,
    };

    let url = Configuration.constants.baseUrl
      + 'api/1.0/companies/' + companyId
      + '/crm/organizations/' + organizationId
      + '/indirect-exact-search-contact/';
    return this.$http.post(url, data);
  }

  loadObjectDescription(companyId, organizationId, objectName, objectsDescriptions, forceReload) {
    let deferred = this.$q.defer();
    // Load new object description if it has never been loaded yet or if we want fresh data (forceReload)
    if (forceReload || !objectsDescriptions[objectName]) {
      this.getObjectDescription(companyId, organizationId, objectName)
        .then(
          response => {
            objectsDescriptions[objectName] = response.data;
            deferred.resolve();
          },
          response => {
            deferred.reject();
          }
        );
    } else {
      deferred.resolve();
    }
    return deferred.promise;
  }

  handleCrmErrors(response, defaultErrorMessageKey, returnRejectedPromise) {
    if (response.status === 502) {
      if (response.data.error.reason === 'server-too-busy') {
        this.AlertingFactory.error('crm/server-too-busy');
      } else if (response.data.error.reason === 'token-expired') {
        this.AlertingFactory.error('crm/token-expired');
      }
    } else if (defaultErrorMessageKey) {
      this.AlertingFactory.error(defaultErrorMessageKey);
    } else {
      this.AlertingFactory.alertHTTPError(response);
    }
    if (returnRejectedPromise) {
      return this.$q.reject(defaultErrorMessageKey);
    }
  }

  static CrmFactory($http, $q, AsyncRequestFactory, AlertingFactory) {
    return new CrmService($http, $q, AsyncRequestFactory, AlertingFactory);
  }
}

CrmService.CrmFactory.$inject = ['$http', '$q', 'AsyncRequestFactory', 'AlertingFactory'];
